// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/yxyweb/common/components/basic/msgcode.less
// module id = 2237
// module chunks = 0